import { put, select, takeLatest } from 'redux-saga/effects'
import { StateCustomDataConstants } from '../store/nemsisCustomData.constants'
import {
  INemsisCustomElementsGroup,
  ISingleStateCustomElement,
  IStateCustomDataDisplayState,
} from '../store/nemsisCustomData.types'
import { setCustomDisplayData } from '../store/nemsisCustomData.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getStateCustomDisplayDataSelector } from '../selectors/stateCustomDisplayData.selector'

export function* deleteCustomElementGroup() {
  try {
    const customDisplayData: IStateCustomDataDisplayState = yield select(getStateCustomDisplayDataSelector)
    const { state, groupId, groupKey, groupingSequence, stateCustomElements } = customDisplayData

    const updatedStateCustomElements = stateCustomElements.map((stateElements: ISingleStateCustomElement) => {
      if (state !== stateElements.state) {
        return stateElements
      }

      const allGroupsForId = stateElements.groups.filter((group) => group.groupId === groupId)
      const isLastGroup = allGroupsForId.length === 1

      return {
        ...stateElements,
        groups: stateElements.groups
          .map((group: INemsisCustomElementsGroup) => {
            if (group.groupKey === groupKey && group.groupingSequence === groupingSequence) {
              if (isLastGroup) {
                return {
                  ...group,
                  customElements: group.customElements?.map((element) => ({
                    ...element,
                    results: [],
                    resultsPNNV: null,
                    _pnnvToggle: false,
                  })),
                }
              }
              return null
            }

            if (group.groupId === groupId && groupingSequence && group.groupingSequence > groupingSequence) {
              return {
                ...group,
                groupingSequence: group.groupingSequence - 1,
              }
            }

            return group
          })
          .filter(Boolean),
      }
    })

    yield put(setCustomDisplayData(updatedStateCustomElements))
  } catch (e) {
    yield put(throwPcrException(`deleteCustomElementGroup() error: ${e}`))
  }
}

export function* deleteCustomElementGroupSaga() {
  yield takeLatest(
    [StateCustomDataConstants.DELETE_CUSTOM_ELEMENT_GROUP],
    performWithMutexHOG,
    deleteCustomElementGroup
  )
}
